export default "__VITE_ASSET__BKwJxDE1__"